import type React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const Upload = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 0 24 24"
		width="24px"
		fill="#000000"
		{...props}
	>
		<g>
			<path d="M5,20h14v-2H5V20z M5,10h4v6h6v-6h4l-7-7L5,10z" />
		</g>
	</svg>
);
